import { useEffect, useState } from "react"

const careersUrl = "https://childrenshomenk.bamboohr.com/careers/"
const jobsUrl = "https://childrenshomenk.bamboohr.com/jobs/embed2.php?version=1.0.0&format=json"

export default function BambooHREmbed() {
  const [jobBoard, setJobBoard] = useState(null)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    // Fetch on each mount instead of relying on the embed script's document-ready event.
    async function loadJobs() {
      try {
        const response = await fetch(jobsUrl, { signal: controller.signal })

        if (!response.ok) {
          throw new Error(`Unable to load BambooHR jobs (${response.status})`)
        }

        const data = await response.json()

        if (!data || data.success === false || !Array.isArray(data.departments) || !data.labels) {
          throw new Error("Unexpected BambooHR job board response")
        }

        if (!controller.signal.aborted) {
          setJobBoard(data)
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error("Unable to load BambooHR jobs", error)
          setHasError(true)
        }
      }
    }

    loadJobs()

    return () => controller.abort()
  }, [])

  return (
    <section>
      <div id="BambooHR" data-domain="childrenshomenk.bamboohr.com" data-version="1.0.0">
        <div id="BambooHR-ATS" aria-busy={!jobBoard && !hasError}>
          {hasError ? (
            <p role="alert">
              We couldn’t load the current openings. <a href={careersUrl}>View our careers page.</a>
            </p>
          ) : jobBoard ? (
            <div className="BambooHR-ATS-board" data-version={jobBoard.version}>
              <h2>{jobBoard.labels.heading}</h2>
              {jobBoard.departments.length > 0 ? (
                <ul className="BambooHR-ATS-Department-List">
                  {jobBoard.departments.map((department) => (
                    <li
                      key={department.id}
                      id={`bhrDepartmentID_${department.id}`}
                      className="BambooHR-ATS-Department-Item"
                    >
                      <div id={`department_${department.id}`} className="BambooHR-ATS-Department-Header">
                        {department.label}
                      </div>
                      <ul className="BambooHR-ATS-Jobs-List">
                        {department.positions.map((position) => (
                          <li key={position.id} id={`bhrPositionID_${position.id}`} className="BambooHR-ATS-Jobs-Item">
                            <a href={/^https?:\/\//i.test(position.url) ? position.url : undefined}>{position.name}</a>
                            <span className="BambooHR-ATS-Location">{position.location}</span>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="BambooHR-ATS-blankState">
                  <strong>{jobBoard.labels.blankStateTitle}</strong>
                  <br />
                  <p>{jobBoard.labels.blankStateBody}</p>
                </div>
              )}
            </div>
          ) : (
            <p role="status">Loading current openings…</p>
          )}
        </div>
        <div id="BambooHR-Footer">
          Powered by{" "}
          <a href="https://www.bamboohr.com" target="_blank" rel="noopener noreferrer">
            <img src="https://resources.bamboohr.com/images/footer-logo.png" alt="BambooHR - HR software" />
          </a>
        </div>
      </div>
    </section>
  )
}
